import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';

export const FLIGHT_PAGE_FILTER = 'FLIGHT_PAGE_FILTER';
export const FLIGHT_PAGE_FILTER_VERSION = '1.0';

export type FlightPageFilterParams = {
  searchParams: SearchParams;
  productDetailKey: string;
  filterName: string;
  value: string;
  deselectFlag: boolean;
};

export type FlightPageFilterPayload = {
  searchId: string;
  productDetailId: string;
  filterName: string;
  filterValue: string;
  deselectFlag: number;
};

export const createFlightPageFilterPayload = (params: FlightPageFilterParams): FlightPageFilterPayload => {
  const { searchParams, productDetailKey, filterName, value, deselectFlag } = params;
  const searchId = searchParams[URLParameters.SEARCH_ID];
  if (!searchId) throw new Error('searchId not present in searchParams');

  const payload = {
    searchId,
    productDetailId: productDetailKey,
    filterName: filterName && filterName.toUpperCase(),
    filterValue: value.toString(),
    deselectFlag: deselectFlag ? 1 : 0,
  };

  return payload;
};
